import { Observable } from 'rxjs';
import { Collaborator, CollaboratorCreateDTO, CollaboratorUpdateDTO } from './entity';

export abstract class CollaboratorRepository {
    abstract list(uid: string, cid: string | null): Observable<Collaborator[]>;
    abstract create(uid: string, cid: string | null, data: CollaboratorCreateDTO): Observable<Collaborator>;
    abstract update(uid: string, cid: string | null, id: number, data: CollaboratorUpdateDTO): Observable<Collaborator>;
    abstract delete(uid: string, cid: string | null, id: number): Observable<void>;
}
